// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"7965b805","633":"8ccf1b2e"}[chunkId] + ".chunk.js";
};